/**
 * Recovery — Recovery-Blatt und sozialer 2-aus-3-Anker (ADR-008).
 *
 * Die Zahlen hier sind Sicherheitsparameter, keine UI-Details. Sie stehen in shared,
 * damit Client und Server dieselbe Wahrheit haben und ein geänderter Wert nicht
 * versehentlich nur an einer Stelle ankommt.
 *
 * Die Kryptografie selbst (Shamir, HMAC, Verschlüsselung der Anteile) liegt in
 * packages/crypto und nutzt ausschließlich geprüfte Bibliotheken.
 */
// --- Recovery-Blatt ----------------------------------------------------------
/** 12 Wörter ≈ 128 Bit. Mehr wäre sicherer und würde seltener aufgeschrieben. */
export const RECOVERY_PHRASE_WORDS = 12;
// --- Sozialer Anker ----------------------------------------------------------
export const SHARE_TOTAL = 3;
export const SHARE_THRESHOLD = 2;
/**
 * Wartezeit zwischen der zweiten Zustimmung und der Herausgabe der Anteile.
 *
 * Das ist die zentrale Gegenmaßnahme zu T13 (Kollusion zweier Verwahrer): Wer den
 * echten Notfall hat, wartet drei Tage. Wer angreift, wird drei Tage lang beobachtet
 * und kann mit einem Tap gestoppt werden. Diese Asymmetrie ist der ganze Schutz —
 * wer den Wert senkt, hebelt ihn aus.
 */
export const RECOVERY_DELAY_HOURS = 72;
/** Nach einem Veto sind neue Anfragen so lange gesperrt. */
export const RECOVERY_BLOCK_DAYS = 7;
/** Eine unbeantwortete Anfrage verfällt. */
export const RECOVERY_REQUEST_TTL_DAYS = 14;
/** Wie oft der Betroffene während der Wartezeit erinnert wird. */
export const RECOVERY_REMINDER_INTERVAL_HOURS = 24;
/** Stellen der Zahl, die Verwahrer telefonisch abgleichen sollen. */
export const VERIFY_CODE_DIGITS = 6;
export const RECOVERY_STATES = [
    'pending', // Anfrage gestellt, weniger als 2 Zustimmungen
    'approved', // 2. Zustimmung da — ab hier läuft die Wartezeit
    'waiting', // Wartezeit läuft (fachlich identisch zu approved, für die UI getrennt)
    'released', // Anteile herausgegeben
    'vetoed', // vom Betroffenen abgebrochen
    'expired',
];
/** Wann dürfen die Anteile herausgegeben werden? */
export function releaseTime(approvedAt) {
    return new Date(approvedAt.getTime() + RECOVERY_DELAY_HOURS * 3_600_000);
}
export function isReleasable(state, approvedAt, now = new Date()) {
    if (state !== 'approved' && state !== 'waiting')
        return false;
    if (!approvedAt)
        return false;
    return now >= releaseTime(approvedAt);
}
export function blockUntil(vetoedAt) {
    return new Date(vetoedAt.getTime() + RECOVERY_BLOCK_DAYS * 86_400_000);
}
/**
 * Ein Veto ist jederzeit möglich, solange die Anteile noch nicht heraus sind.
 * Bewusst großzügig: Der Betroffene soll nie das Gefühl haben, zu spät zu sein.
 */
export function canVeto(state) {
    return state === 'pending' || state === 'approved' || state === 'waiting';
}
/**
 * Ist der Anker noch benutzbar? Verliert ein Verwahrer sein Gerät, sinkt die Zahl
 * der einlösbaren Anteile — bei weniger als der Schwelle ist der Anker wertlos und
 * muss neu aufgeteilt werden. Die App prüft das und erinnert, statt es im Ernstfall
 * herauszufinden.
 */
export function anchorHealth(activeShares) {
    if (activeShares >= SHARE_TOTAL)
        return 'ok';
    if (activeShares >= SHARE_THRESHOLD)
        return 'at_risk';
    return 'broken';
}
//# sourceMappingURL=recovery.js.map